/* ---- part 1 ---- */
document.querySelectorAll('.upsell-input').forEach(function (checkbox) {
  checkbox.addEventListener('change', function () {
    var variantId = this.dataset.variantId;
    if (!variantId) return; // Tech toggle with no variant → skip cart

    if (this.checked) {
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: parseInt(variantId), quantity: 1 })
      })
      .then(function (r) { return r.json(); })
      .then(function () {
        document.dispatchEvent(new CustomEvent('cart:refresh'));
      })
      .catch(function (e) { console.error('[Upsell] Add failed:', e); });
    } else {
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: parseInt(variantId), quantity: 0 })
      })
      .then(function (r) { return r.json(); })
      .then(function () {
        document.dispatchEvent(new CustomEvent('cart:refresh'));
      })
      .catch(function (e) { console.error('[Upsell] Remove failed:', e); });
    }
  });
});

/* Shared variant-select sync.

   A PDP can carry more than one variant picker (the repeat buy section below
   the FAQs), and each picker renders its own set of native <select>s. Indexing
   them flat across the page matches the second picker's select against an
   option value that does not exist, so it never updates. Index each select
   within its own <product-variants> wrapper instead.

   The value guard also stops the change event from recursing: by the time the
   handler re-enters, every select already holds the new value. */
window.__vpSyncNativeSelects = function (title) {
  var values = String(title).split(' / ');
  var selects = document.querySelectorAll('[data-vp-native-select]');
  Array.prototype.forEach.call(selects, function (sel) {
    var scope = sel.closest('product-variants') || document;
    var group = Array.prototype.slice.call(scope.querySelectorAll('[data-vp-native-select]'));
    var i = group.indexOf(sel);
    var val = values[i > -1 ? i : 0];
    if (val == null) val = values[0];
    if (val == null || sel.value === val) return;
    sel.value = val;
    sel.dispatchEvent(new Event('change', { bubbles: true }));
  });
};

/* ---- part 2 ---- */
document.addEventListener("click", function (e) {
  const option = e.target.closest("[data-vp-option]");
  if (!option) return;

  const variantId = option.dataset.variantId;
  const jsonEl = document.querySelector("[data-js-variant-data]");
  if (!jsonEl) {
    return;
  }

  let currentVariant;
  try {
    currentVariant = JSON.parse(jsonEl.textContent);
  } catch (err) {
    return;
  }
  let productVariants = window.productVariants || window.variants || null;

  if (!productVariants) {
    const allOptions = document.querySelectorAll("[data-vp-option]");
    productVariants = Array.from(allOptions).map(el => ({
      id: el.dataset.variantId,
      title: el.dataset.variantTitle
    }));
  }

  const selectedVariant = productVariants.find(v => String(v.id) === String(variantId));

  if (!selectedVariant) {
    console.log("Variant not found in list");
    return;
  }
  const selects = document.querySelectorAll("[data-vp-native-select]");

  if (selects.length === 0) {
    console.log("No selects found");
  }

  window.__vpSyncNativeSelects(selectedVariant.title);

  const formInputs = document.querySelectorAll('form[action="/cart/add"] input[name="id"]');
  if (formInputs.length) {
    formInputs.forEach((input) => { input.value = variantId; });
  } else {
    console.log("Add to cart input not found");
  }
});

/* ---- part 3 ---- */
/* Quantity selector, chosen per buy_buttons block via data-qty-style.

   'dropdown' (the theme default) hides the - / + buttons and swaps in a
   1..max <select>. 'stepper' keeps the theme's - 1 + buttons, which
   component-quantity-selector.js drives off the input's own min/max.

   Runs per <product-quantity> wrapper, never once for the page: a single-match
   version hid EVERY .qty-button but built one dropdown, leaving a second
   buy_buttons block with no way to change the quantity at all. */
document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll("product-quantity").forEach(function (holder) {
    if (holder.dataset.qtyReady === "true") return;
    holder.dataset.qtyReady = "true";

    // Stepper: the theme markup is already correct, nothing to build.
    if (holder.dataset.qtyStyle !== "dropdown") return;

    var qtyInput = holder.querySelector(".product__quantity");
    if (!qtyInput) return;

    holder.querySelectorAll(".qty-button").forEach(function (btn) {
      btn.style.display = "none";
    });

    var max = parseInt(qtyInput.getAttribute("max"), 10);
    if (!(max > 0)) max = 10;

    var select = document.createElement("select");
    select.className = "qty-dropdown";
    for (var i = 1; i <= max; i++) {
      var option = document.createElement("option");
      option.value = i;
      option.textContent = i;
      if (i == qtyInput.value) option.selected = true;
      select.appendChild(option);
    }
    qtyInput.style.display = "none";
    qtyInput.parentNode.appendChild(select);

    select.addEventListener("change", function () {
      qtyInput.value = this.value;
      qtyInput.dispatchEvent(new Event("change", { bubbles: true }));
    });
    qtyInput.addEventListener("change", function () {
      select.value = this.value;
    });
  });
});

/* component-quantity-selector.js writes qty.value directly and fires no event,
   so nothing downstream would notice a stepper click. Re-broadcast it: this
   listener is on document, so it runs after the component's own button handler
   and sees the updated value. Delegated, so it covers every block. */
document.addEventListener("click", function (e) {
  var btn = e.target.closest && e.target.closest(".qty-minus, .qty-plus");
  if (!btn) return;
  var holder = btn.closest("product-quantity");
  var qty = holder && holder.querySelector(".qty-selector");
  if (!qty) return;
  qty.dispatchEvent(new Event("input", { bubbles: true }));
  qty.dispatchEvent(new Event("change", { bubbles: true }));
});

/* Clamp a TYPED quantity to the input's own min/max. The stepper buttons are
   clamped by component-quantity-selector.js, but the <input type="number"> can
   still be typed to 0 or a negative value; the live site rejects those, so mirror
   that here. Delegated on document, so it covers every quantity field on the page. */
document.addEventListener("change", function (e) {
  var qty = e.target.closest && e.target.closest(".product__quantity, .qty-selector");
  if (!qty) return;
  var min = parseInt(qty.getAttribute("min"), 10);
  if (!(min >= 1)) min = 1;
  var max = parseInt(qty.getAttribute("max"), 10);
  var val = parseInt(qty.value, 10);
  if (isNaN(val) || val < min) val = min;
  if (max > 0 && val > max) val = max;
  if (String(val) !== String(qty.value)) {
    qty.value = val;
    qty.dispatchEvent(new Event("input", { bubbles: true }));
  }
});

/* ---- part 4 ---- */
(function () {
  function initDrawer(triggerBtn) {
    var targetId = triggerBtn.getAttribute("data-ttd-target");
    var blockId = targetId.replace("ttd-drawer-", "");

    var drawer = document.getElementById("ttd-drawer-" + blockId);
    var overlay = document.getElementById("ttd-overlay-" + blockId);
    var closeBtn = drawer
      ? drawer.querySelector("[data-ttd-close]")
      : null;

    if (!drawer || !overlay) return;

    function openDrawer() {
      drawer.classList.add("is-open");
      overlay.classList.add("is-open");
      document.body.style.overflow = "hidden";
      drawer.focus();
    }

    function closeDrawer() {
      drawer.classList.remove("is-open");
      overlay.classList.remove("is-open");
      document.body.style.overflow = "";
      triggerBtn.focus();
    }

    triggerBtn.addEventListener("click", openDrawer);
    overlay.addEventListener("click", closeDrawer);

    if (closeBtn) {
      closeBtn.addEventListener("click", closeDrawer);
    }

    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape" && drawer.classList.contains("is-open")) {
        closeDrawer();
      }
    });
  }

  function init() {
    var triggers = document.querySelectorAll("[data-ttd-target]");
    triggers.forEach(function (btn) {
      initDrawer(btn);
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();

/* ---- part 5 ---- */
(function () {

  function initIcontextDrawer(triggerBtn) {
    var targetId = triggerBtn.getAttribute("data-icontext-target");
    var blockId  = targetId.replace("icontext-drawer-", "");

    var drawer   = document.getElementById("icontext-drawer-" + blockId);
    var overlay  = document.getElementById("icontext-overlay-" + blockId);
    var closeBtn = drawer ? drawer.querySelector("[data-icontext-close]") : null;

    if (!drawer || !overlay) return;

    function openDrawer() {
      drawer.classList.add("is-open");
      overlay.classList.add("is-open");
      document.body.style.overflow = "hidden";
    }

    function closeDrawer() {
      drawer.classList.remove("is-open");
      overlay.classList.remove("is-open");
      document.body.style.overflow = "";
      triggerBtn.focus();
    }

    triggerBtn.addEventListener("click", openDrawer);
    overlay.addEventListener("click", closeDrawer);

    if (closeBtn) {
      closeBtn.addEventListener("click", closeDrawer);
    }

    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape" && drawer.classList.contains("is-open")) {
        closeDrawer();
      }
    });
  }

  function init() {
    document
      .querySelectorAll("[data-icontext-target]")
      .forEach(function (btn) {
        initIcontextDrawer(btn);
      });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }

})();

/* ---- part 6 ---- */
(function () {

  function initTabs(wrap) {
    var group   = wrap.id.replace('ptabs-', '');
    var buttons = wrap.querySelectorAll('[data-ptab-group="' + group + '"]');
    var panels  = wrap.querySelectorAll('.ptabs-panel');

    function activateTab(btn) {
      buttons.forEach(function (b) {
        b.classList.remove('ptabs-nav-btn--active');
        b.setAttribute('aria-selected', 'false');
      });
      panels.forEach(function (p) {
        p.classList.remove('ptabs-panel--active');
      });

      btn.classList.add('ptabs-nav-btn--active');
      btn.setAttribute('aria-selected', 'true');

      var targetId = btn.getAttribute('data-ptab-target');
      var panel    = document.getElementById(targetId);
      if (panel) panel.classList.add('ptabs-panel--active'); 
      btn.scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
    }

    buttons.forEach(function (btn) {
      btn.addEventListener('mouseenter', function () {
        activateTab(btn);
      });
      btn.addEventListener('click', function () {
        activateTab(btn);
      });
    });
  }

  function init() {
    document.querySelectorAll('.ptabs-wrap').forEach(function (wrap) {
      initTabs(wrap);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();

/* ---- part 7 ---- */
document.addEventListener("DOMContentLoaded", function () {
  const styles = document.querySelectorAll("style");

  const seen = new Set();

  styles.forEach((style) => {
    const content = style.innerHTML.trim();

    if (seen.has(content)) {
      style.remove(); 
    } else {
      seen.add(content);
    }
  });
});

/* ---- part 8 ---- */
document.addEventListener("DOMContentLoaded", function () {
  const items = document.querySelectorAll(".ptabs-benefit-text");

  items.forEach(el => {
    const text = el.textContent;

    if (text.includes(":")) {
      const parts = text.split(":");

      const before = parts[0].trim();
      const after = parts.slice(1).join(":").trim();

      el.innerHTML = `<strong>${before}:</strong> ${after}`;
    }
  });
});

/* ---- part 9 ---- */
(function () {
  const modal = document.querySelector('.vp-sg-overlay');
  const openBtn = document.querySelector('[data-vp-size-guide-open]');
  const closeBtn = document.querySelector('[data-vp-sg-close]');

  if (!modal) return;

  function disableScroll() {
    document.body.style.overflow = 'hidden';
  }
  function enableScroll() {
    document.body.style.overflow = '';
  }
  openBtn && openBtn.addEventListener('click', () => {
    modal.removeAttribute('hidden');
    disableScroll();
  });
  closeBtn && closeBtn.addEventListener('click', () => {
    modal.setAttribute('hidden', true);
    enableScroll();
  });
  modal.addEventListener('click', (e) => {
    if (e.target === modal) {
      modal.setAttribute('hidden', true);
      enableScroll();
    }
  });
})();

/* ---- part 10 ---- */
(function () {
  const modal = document.querySelector('.vp-sg-overlay');
  const openBtn = document.querySelector('.vp-size-guide-btn');
  const closeBtn = document.querySelector('[data-vp-sg-close]');

  if (!modal) return;

  function openModal() {
    modal.removeAttribute('hidden');

    requestAnimationFrame(() => {
      modal.classList.add('is-open');
      document.body.classList.add('no-scroll');
    });
  }

  function closeModal() {
    modal.classList.remove('is-open');
    document.body.classList.remove('no-scroll');

    setTimeout(() => {
      modal.setAttribute('hidden', true);
    }, 500); 
  }

  openBtn && openBtn.addEventListener('click', openModal);
  closeBtn && closeBtn.addEventListener('click', closeModal);

  modal.addEventListener('click', (e) => {
    if (e.target === modal) closeModal();
  });
})();

/* ---- part 11 ---- */
(function () {
  const drawer = document.querySelector('.ttd-drawer');
  if (!drawer) return;

  const openBtn = document.querySelector('[data-ttd-open]');
  const closeBtn = drawer.querySelector('[data-ttd-close]');
  const header = document.querySelector('header');
  let overlay = document.querySelector('.ttd-overlay');
  if (!overlay) {
    overlay = document.createElement('div');
    overlay.className = 'ttd-overlay';
    document.body.appendChild(overlay);
  }

  let prevHeaderZ = '';

  function openDrawer() {
    if (header) {
      prevHeaderZ = header.style.zIndex;
      header.style.zIndex = '10';
    }
    document.body.appendChild(drawer);
    overlay.classList.add('is-open');
    drawer.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  }

  function closeDrawer() {
    overlay.classList.remove('is-open');
    drawer.classList.remove('is-open');
    document.body.style.overflow = '';
    if (header) {
      header.style.zIndex = prevHeaderZ || '';
    }
  }
  openBtn && openBtn.addEventListener('click', openDrawer);
  closeBtn && closeBtn.addEventListener('click', closeDrawer);
  overlay.addEventListener('click', closeDrawer);
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') closeDrawer();
  });
})();

/* ---- part 12 ---- */
document.documentElement.classList.add('js-ready');

/* ---- part 13 ---- */
document.addEventListener("DOMContentLoaded", function () {
  const upsellInputs = document.querySelectorAll(".upsell-input");

  upsellInputs.forEach(input => {
    input.addEventListener("change", function (e) {
      // Allow UI toggle BUT stop everything else
      e.stopImmediatePropagation();
    }, true);
  });
});

/* ---- part 14 ---- */
/* Swap the upsell label between its checked and unchecked wording.

   This used to bind a `change` listener to each .upsell-input directly, and it
   never fired: part 13 above attaches a CAPTURE-phase listener to those same
   inputs that calls stopImmediatePropagation(), and it registers first, so
   every later listener on the element was killed. The label read the same in
   both states however the two data-title-* values were set.

   Delegated from document in the capture phase instead -- document capture runs
   before any listener on the target, so part 13 cannot cut it off. Delegation
   also survives the buy area being re-rendered on variant change. */
(function () {
  function applyTitle(input) {
    var row = input.closest('.upsell-row, .upsell-row-wrap, .upsell-row-wp');
    if (!row) return;
    var label = row.querySelector('.upsell-label[data-title-checked]');
    if (!label) return;
    var titleEl = label.querySelector('.upsell-dynamic-title');
    if (!titleEl) return;
    var next = input.checked
      ? label.getAttribute('data-title-checked')
      : label.getAttribute('data-title-unchecked');
    if (next != null && titleEl.textContent !== next) titleEl.textContent = next;
  }

  function syncAll() {
    Array.prototype.forEach.call(document.querySelectorAll('.upsell-input'), applyTitle);
  }

  document.addEventListener('change', function (e) {
    var input = e.target;
    if (input && input.classList && input.classList.contains('upsell-input')) {
      applyTitle(input);
    }
  }, true);

  // A click lands before the change event is dispatched in some browsers, and
  // the buy area can re-render underneath us; both are cheap to re-check.
  document.addEventListener('click', function (e) {
    var input = e.target.closest && e.target.closest('.upsell-row, .upsell-row-wrap, .upsell-row-wp');
    if (input) requestAnimationFrame(syncAll);
  }, true);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', syncAll);
  } else {
    syncAll();
  }
})();

/* ---- part 15 ---- */
document.addEventListener('DOMContentLoaded', function () {
  const slider = document.querySelector('.custom-badge-scroll');

  if (!slider) return;

  let isDown = false;
  let startX;
  let scrollLeft;

  // Mouse drag scroll
  slider.addEventListener('mousedown', (e) => {
    isDown = true;
    slider.classList.add('active');
    startX = e.pageX - slider.offsetLeft;
    scrollLeft = slider.scrollLeft;
  });

  slider.addEventListener('mouseleave', () => {
    isDown = false;
  });

  slider.addEventListener('mouseup', () => {
    isDown = false;
  });

  slider.addEventListener('mousemove', (e) => {
    if (!isDown) return;
    e.preventDefault();
    const x = e.pageX - slider.offsetLeft;
    const walk = (x - startX) * 1.5; // speed
    slider.scrollLeft = scrollLeft - walk;
  });

  // Mouse wheel → horizontal scroll
  slider.addEventListener('wheel', (e) => {
    if (e.deltaY !== 0) {
      e.preventDefault();
      slider.scrollLeft += e.deltaY;
    }
  });
});

/* ---- part 16 ---- */
(function () {
  function initGalleryArrows() {
    const gallery = document.querySelector('.product-gallery');
    if (!gallery) return;

    gallery.querySelectorAll('.custom-gallery-arrow').forEach(el => el.remove());
    document.querySelectorAll('.custom-gallery-arrow').forEach(el => el.remove());

    const cssSlider = gallery.querySelector('css-slider');
    const viewport  = gallery.querySelector('.css-slider-viewport');

    if (!cssSlider || !viewport) {
      setTimeout(initGalleryArrows, 300);
      return;
    }

    function getThumbs() {
      return Array.from(gallery.querySelectorAll('.thumbnail[data-index]'));
    }
    function getSlides() {
      return Array.from(gallery.querySelectorAll('.css-slide'));
    }
    function getCurrentIndex() {
      const slides = getSlides();
      const idx = slides.findIndex(s => s.classList.contains('css-slide-active'));
      return idx >= 0 ? idx : 0;
    }
    function goTo(index) {
      const total = getSlides().length;
      if (index < 0 || index >= total) return;
      const thumb = getThumbs().find(t => parseInt(t.dataset.index) === index);
      if (thumb) thumb.click();
      setTimeout(updateButtons, 100);
    }
    function updateButtons() {
      const total = getSlides().length;
      const index = getCurrentIndex();
      if (total <= 1) {
        prevBtn.style.display = 'none';
        nextBtn.style.display = 'none';
        return;
      }
      prevBtn.style.display       = 'flex';
      nextBtn.style.display       = 'flex';
      prevBtn.style.opacity       = index <= 0 ? '0.3' : '1';
      prevBtn.style.pointerEvents = index <= 0 ? 'none' : 'auto';
      nextBtn.style.opacity       = index >= total - 1 ? '0.3' : '1';
      nextBtn.style.pointerEvents = index >= total - 1 ? 'none' : 'auto';
    }

    const prevBtn = document.createElement('button');
    prevBtn.className = 'custom-gallery-arrow custom-gallery-arrow--prev';
    prevBtn.setAttribute('aria-label', 'Previous image');
    prevBtn.innerHTML = `<svg fill="none" height="12" viewBox="0 0 8 14" width="8" xmlns="http://www.w3.org/2000/svg">
      <path d="M6.5 13L1 7l5.5-6" stroke="#000" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>`;

    const nextBtn = document.createElement('button');
    nextBtn.className = 'custom-gallery-arrow custom-gallery-arrow--next';
    nextBtn.setAttribute('aria-label', 'Next image');
    nextBtn.innerHTML = `<svg fill="none" height="12" viewBox="0 0 8 14" width="8" xmlns="http://www.w3.org/2000/svg">
      <path d="M1.5 1L7 7l-5.5 6" stroke="#000" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>`;

    [prevBtn, nextBtn].forEach(btn => {
      Object.assign(btn.style, {
        position       : 'absolute',
        top            : '50%',
        transform      : 'translateY(-50%)',
        width          : '48px',
        height         : '48px',
        borderRadius   : '50%',
        background     : 'rgba(255,255,255,0.95)',
        border         : '1px solid #ddd',
        boxShadow      : '0 2px 8px rgba(0,0,0,0.18)',
        cursor         : 'pointer',
        zIndex         : '9',
        display        : 'flex',
        alignItems     : 'center',
        justifyContent : 'center',
        padding        : '0',
        outline        : 'none',
        transition     : 'opacity 0.2s, box-shadow 0.2s',
        flexShrink     : '0',
      });
    });

    prevBtn.style.left  = '10px';
    nextBtn.style.right = '10px';

    [prevBtn, nextBtn].forEach(btn => {
      btn.addEventListener('mouseenter', () => btn.style.boxShadow = '0 4px 14px rgba(0,0,0,0.28)');
      btn.addEventListener('mouseleave', () => btn.style.boxShadow = '0 2px 8px rgba(0,0,0,0.18)');
    });

    prevBtn.addEventListener('click', e => { e.stopPropagation(); e.preventDefault(); goTo(getCurrentIndex() - 1); });
    nextBtn.addEventListener('click', e => { e.stopPropagation(); e.preventDefault(); goTo(getCurrentIndex() + 1); });

    cssSlider.style.position = 'relative';
    cssSlider.appendChild(prevBtn);
    cssSlider.appendChild(nextBtn);

    function positionArrows() {
      const vRect = viewport.getBoundingClientRect();
      const sRect = cssSlider.getBoundingClientRect();
      if (vRect.height === 0) { setTimeout(positionArrows, 200); return; }

      const btnSize  = prevBtn.offsetWidth || 36;
      const halfBtn  = btnSize / 2;
      const centerY  = (vRect.top - sRect.top) + vRect.height / 2;
      const minTop = (vRect.top - sRect.top) + halfBtn;
      const maxTop = (vRect.top - sRect.top) + vRect.height - halfBtn;
      const clampedY = Math.min(Math.max(centerY, minTop), maxTop);
      const vLeft    = vRect.left - sRect.left;
      const vRight   = vLeft + vRect.width;
      const leftPos  = Math.max(vLeft + 15, vLeft + 15);
      const rightPos = Math.max(sRect.width - vRight + 15, 15);

      prevBtn.style.top       = clampedY + 'px';
      nextBtn.style.top       = clampedY + 'px';
      prevBtn.style.transform = 'translateY(-50%)';
      nextBtn.style.transform = 'translateY(-50%)';
      prevBtn.style.left      = leftPos + 'px';
      nextBtn.style.right     = rightPos + 'px';
      nextBtn.style.left      = 'auto';
      prevBtn.style.right     = 'auto';
    }

    const thumbHolder = gallery.querySelector('.product-gallery__thumbnails-holder');
    if (thumbHolder) {
      new MutationObserver(() => setTimeout(updateButtons, 80))
        .observe(thumbHolder, { subtree: true, attributes: true, attributeFilter: ['class'] });
    }

    getSlides().forEach(slide => {
      new MutationObserver(mutations => {
        mutations.forEach(m => {
          if (m.attributeName === 'inert') slide.removeAttribute('inert');
        });
      }).observe(slide, { attributes: true, attributeFilter: ['inert'] });
    });

    updateButtons();

    function tryPosition() {
      if (viewport.getBoundingClientRect().height > 0) {
        positionArrows();
      } else {
        setTimeout(tryPosition, 150);
      }
    }
    tryPosition();

    window.addEventListener('resize', positionArrows);
    new ResizeObserver(positionArrows).observe(viewport);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initGalleryArrows);
  } else {
    initGalleryArrows();
  }

  document.addEventListener('shopify:section:load', initGalleryArrows);
})();

/* ---- part 17 ---- */
(function () {
  function initGalleryArrows() {
    const gallery = document.querySelector('.product-gallery');
    if (!gallery) return;

    gallery.querySelectorAll('.custom-gallery-arrow').forEach(el => el.remove());

    const cssSlider = gallery.querySelector('css-slider');
    const viewport  = gallery.querySelector('.css-slider-viewport');

    if (!cssSlider || !viewport) {
      setTimeout(initGalleryArrows, 300);
      return;
    }


    function getSlides() {
      return Array.from(cssSlider.querySelectorAll('.css-slide'));
    }
    function getThumbs() {
      return Array.from(gallery.querySelectorAll('.thumbnail[data-index]'));
    }
    function getCurrentIndex() {
      const slides = getSlides();
      const idx = slides.findIndex(s => s.classList.contains('css-slide-active'));
      return idx >= 0 ? idx : 0;
    }

    function goTo(index) {
      const slides = getSlides();
      const total  = slides.length;
      if (!total) return;

      if (index < 0) index = total - 1;
      if (index >= total) index = 0;

      slides.forEach((s, i) => {
        if (i === index) {
          s.classList.add('css-slide-active');
          s.removeAttribute('inert');
          s.setAttribute('tabindex', '0');
        } else {
          s.classList.remove('css-slide-active');
          s.setAttribute('inert', '');
          s.setAttribute('tabindex', '-1');
        }
      });

      getThumbs().forEach(t => {
        const isActive = parseInt(t.dataset.index) === index;
        t.classList.toggle('is-active', isActive);
        t.classList.toggle('thumbnail--active', isActive);
      });

      const holder = viewport.querySelector('.css-slider-holder');
      if (holder) {
        try {
          const slideEl = slides[index];
          if (slideEl) {
            slideEl.scrollIntoView({ block: 'nearest', inline: 'start' });
          }
        } catch(e) {}
      }

      updateButtons();
    }

    function updateButtons() {
      const total = getSlides().length;
      [prevBtn, nextBtn].forEach(b => {
        b.style.display       = total > 1 ? 'flex' : 'none';
        b.style.opacity       = '1';
        b.style.pointerEvents = 'auto';
      });
    }

    const prevBtn = document.createElement('button');
    prevBtn.className = 'custom-gallery-arrow custom-gallery-arrow--prev';
    prevBtn.setAttribute('aria-label', 'Previous image');
    prevBtn.innerHTML = `<svg fill="none" height="12" viewBox="0 0 8 14" width="8" xmlns="http://www.w3.org/2000/svg">
      <path d="M6.5 13L1 7l5.5-6" stroke="#000" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>`;

    const nextBtn = document.createElement('button');
    nextBtn.className = 'custom-gallery-arrow custom-gallery-arrow--next';
    nextBtn.setAttribute('aria-label', 'Next image');
    nextBtn.innerHTML = `<svg fill="none" height="12" viewBox="0 0 8 14" width="8" xmlns="http://www.w3.org/2000/svg">
      <path d="M1.5 1L7 7l-5.5 6" stroke="#000" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>`;

    [prevBtn, nextBtn].forEach(btn => {
      Object.assign(btn.style, {
        position       : 'absolute',
        top            : '50%',
        transform      : 'translateY(-50%)',
        width          : '48px',
        height         : '48px',
        borderRadius   : '50%',
        background     : 'rgba(255,255,255,0.95)',
        border         : '1px solid #ddd',
        boxShadow      : '0 2px 8px rgba(0,0,0,0.18)',
        cursor         : 'pointer',
        zIndex         : '9',
        display        : 'flex',
        alignItems     : 'center',
        justifyContent : 'center',
        padding        : '0',
        outline        : 'none',
        transition     : 'box-shadow 0.2s',
        flexShrink     : '0',
      });
      btn.addEventListener('mouseenter', () => btn.style.boxShadow = '0 4px 14px rgba(0,0,0,0.28)');
      btn.addEventListener('mouseleave', () => btn.style.boxShadow = '0 2px 8px rgba(0,0,0,0.18)');
    });

    prevBtn.style.left  = '10px';
    nextBtn.style.right = '10px';

    prevBtn.addEventListener('click', e => { e.stopPropagation(); e.preventDefault(); goTo(getCurrentIndex() - 1); });
    nextBtn.addEventListener('click', e => { e.stopPropagation(); e.preventDefault(); goTo(getCurrentIndex() + 1); });

    cssSlider.style.position = 'relative';
    cssSlider.appendChild(prevBtn);
    cssSlider.appendChild(nextBtn);

    function positionArrows() {
      const vRect = viewport.getBoundingClientRect();
      const sRect = cssSlider.getBoundingClientRect();
      if (vRect.height === 0) { setTimeout(positionArrows, 200); return; }

      const centerY = (vRect.top - sRect.top) + vRect.height / 2;
      const vLeft   = vRect.left - sRect.left;
      const vRight  = vLeft + vRect.width;

      prevBtn.style.top   = centerY + 'px';
      nextBtn.style.top   = centerY + 'px';
      prevBtn.style.left  = Math.max(vLeft + 15, 10) + 'px';
      nextBtn.style.right = Math.max(sRect.width - vRight + 15, 10) + 'px';
      nextBtn.style.left  = 'auto';
      prevBtn.style.right = 'auto';
    }

    updateButtons();
    const tryPos = () => viewport.getBoundingClientRect().height > 0
      ? positionArrows()
      : setTimeout(tryPos, 150);
    tryPos();
    window.addEventListener('resize', positionArrows);
    new ResizeObserver(positionArrows).observe(viewport);

    let touchStartX  = 0;
    let touchStartY  = 0;
    let touchFired   = false;
    let axisDecided  = false;
    let isHoriz      = false;
    let startScrollLeft = 0;

    viewport.addEventListener('touchstart', function (e) {
      touchStartX     = e.touches[0].clientX;
      touchStartY     = e.touches[0].clientY;
      touchFired      = false;
      axisDecided     = false;
      isHoriz         = false;
      startScrollLeft = viewport.scrollLeft;
    }, { passive: true, capture: true });

    viewport.addEventListener('touchmove', function (e) {
      const dx = e.touches[0].clientX - touchStartX;
      const dy = e.touches[0].clientY - touchStartY;

      if (!axisDecided && (Math.abs(dx) > 8 || Math.abs(dy) > 8)) {
        isHoriz    = Math.abs(dx) > Math.abs(dy);
        axisDecided = true;
      }

      if (isHoriz) {
        e.preventDefault();
        e.stopPropagation();
      }
    }, { passive: false, capture: true });

    viewport.addEventListener('touchend', function (e) {
      if (touchFired || !axisDecided || !isHoriz) return;

      const dx = e.changedTouches[0].clientX - touchStartX;

      if (Math.abs(dx) >= 20) {
        touchFired = true;
        e.preventDefault();
        e.stopPropagation();
        goTo(getCurrentIndex() + (dx < 0 ? 1 : -1));
      }
    }, { passive: false, capture: true });

    viewport.addEventListener('touchcancel', function () {
      touchFired  = false;
      axisDecided = false;
      isHoriz     = false;
    }, { passive: true });

    let wheelLocked   = false;
    let wheelAccum    = 0;
    const LOCK_MS     = 700;
    const THRESHOLD   = 15;
    viewport.addEventListener('wheel', function (e) {
      const absX = Math.abs(e.deltaX);
      const absY = Math.abs(e.deltaY);

      if (absX <= absY) return; 

      e.preventDefault();
      e.stopPropagation();

      if (wheelLocked) return;

      wheelAccum += e.deltaX;

      if (Math.abs(wheelAccum) >= THRESHOLD) {
        const dir   = wheelAccum > 0 ? 1 : -1;
        wheelAccum  = 0;
        wheelLocked = true;
        goTo(getCurrentIndex() + dir);
        setTimeout(() => { wheelLocked = false; }, LOCK_MS);
      }
    }, { passive: false, capture: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initGalleryArrows);
  } else {
    initGalleryArrows();
  }

  document.addEventListener('shopify:section:load', initGalleryArrows);
})();

/* ---- part 18 ---- */
(function () {
  function initGalleryArrows() {
    const gallery = document.querySelector('.product-gallery');
    if (!gallery) return;

    gallery.querySelectorAll('.custom-gallery-arrow').forEach(el => el.remove());

    const cssSlider = gallery.querySelector('css-slider');
    const viewport  = gallery.querySelector('.css-slider-viewport');

    if (!cssSlider || !viewport) {
      setTimeout(initGalleryArrows, 300);
      return;
    }

    function getRealSlides() {
      return Array.from(cssSlider.querySelectorAll('.css-slide:not(.clone-slide)'));
    }

    /* ── Build clones (only once) ── */
    function buildClones() {
      if (cssSlider.querySelector('.clone-slide')) return; // already built

      const real = getRealSlides();
      if (real.length < 2) return;

      const firstClone = real[0].cloneNode(true);
      const lastClone  = real[real.length - 1].cloneNode(true);
      firstClone.classList.add('clone-slide');
      lastClone.classList.add('clone-slide');
      firstClone.setAttribute('aria-hidden', 'true');
      lastClone.setAttribute('aria-hidden', 'true');
      // Strip snap/active so clones never enter the slider's indexedItems
      firstClone.classList.remove('css-slide--snap', 'css-slide-active');
      lastClone.classList.remove('css-slide--snap', 'css-slide-active');
      firstClone.removeAttribute('data-index');
      lastClone.removeAttribute('data-index');

      // append clone of first → appears after last
      real[real.length - 1].after(firstClone);
      // prepend clone of last → appears before first
      real[0].before(lastClone);

      // Inserting lastClone before real[0] shifts everything right.
      // Restore scroll so real[0] stays visible (holder was at its offsetLeft).
      const holder = cssSlider.querySelector('.css-slider-holder') || viewport;
      const marginLeft = parseInt(getComputedStyle(real[0]).marginLeft) || 0;
      holder.scrollLeft = Math.max(0, real[0].offsetLeft - marginLeft);
    }

    function getAllSlides() {
      return Array.from(cssSlider.querySelectorAll('.css-slide'));
    }

    /* ── Activate a slide by DOM index in getAllSlides() ── */
    let isTransitioning = false;

    function activateByDomIndex(domIdx, animate) {
      const all   = getAllSlides();
      const slide = all[domIdx];
      if (!slide) return;

      // Clones are scroll-targets for the loop illusion only — never mark them active.
      // When a clone is the target, keep the active class on the nearest real counterpart.
      const isClone  = slide.classList.contains('clone-slide');
      const realSlides = getRealSlides();
      // real counterpart: clone-of-last is before real[0] (domIdx=0), clone-of-first is after real[N]
      const realTarget = isClone
        ? (domIdx === 0 ? realSlides[realSlides.length - 1] : realSlides[0])
        : slide;

      all.forEach(s => {
        const active = s === realTarget && !s.classList.contains('clone-slide');
        s.classList.toggle('css-slide-active', active);
        if (active) {
          s.removeAttribute('inert');
          s.setAttribute('tabindex', '0');
        } else {
          s.setAttribute('inert', '');
          s.setAttribute('tabindex', '-1');
        }
      });

      /* Scroll the viewport */
      const holder = viewport.querySelector('.css-slider-holder') || viewport;
      if (animate) {
        slide.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });
      } else {
        slide.scrollIntoView({ behavior: 'instant', block: 'nearest', inline: 'start' });
      }

      updateButtons();
    }

    /* ── Get current real index (0-based among real slides) ── */
    function getRealIndex() {
      const real    = getRealSlides();
      const active  = cssSlider.querySelector('.css-slide-active');
      if (!active) return 0;
      const idx = real.indexOf(active);
      return idx >= 0 ? idx : 0;
    }

    /* ── Get DOM index of real slide by real index ── */
    function domIndexOfReal(realIdx) {
      const real = getRealSlides();
      const all  = getAllSlides();
      const slide = real[realIdx];
      return all.indexOf(slide);
    }

    /* ── Navigate by +1 / -1 ── */
    function go(dir) {
      if (isTransitioning) return;

      const real     = getRealSlides();
      if (real.length < 2) return;

      buildClones();

      const all      = getAllSlides();
      const active   = cssSlider.querySelector('.css-slide-active') || real[0];
      let   domIdx   = all.indexOf(active);

      const targetDom = domIdx + dir;

      if (targetDom < 0 || targetDom >= all.length) return; // safety

      isTransitioning = true;
      activateByDomIndex(targetDom, true);

      setTimeout(() => {
        /* If we landed on a clone, silently snap to the real counterpart */
        const landed = all[targetDom];
        if (landed && landed.classList.contains('clone-slide')) {
          const newReal = getRealSlides();
          // clone of first → snap to last real; clone of last → snap to first real
          const snapToReal = dir > 0 ? 0 : newReal.length - 1;
          activateByDomIndex(domIndexOfReal(snapToReal), false /* instant */);
        }
        isTransitioning = false;
      }, 420); // slightly longer than your typical scroll-snap settle time
    }

    /* ── Thumbnails sync ── */
    function syncThumbs() {
      const realIdx = getRealIndex();
      gallery.querySelectorAll('.thumbnail[data-index]').forEach(t => {
        const active = parseInt(t.dataset.index) === realIdx;
        t.classList.toggle('is-active', active);
        t.classList.toggle('thumbnail--active', active);
      });
    }

    function updateButtons() {
      const total = getRealSlides().length;
      [prevBtn, nextBtn].forEach(b => {
        b.style.display       = total > 1 ? 'flex' : 'none';
        b.style.opacity       = '1';
        b.style.pointerEvents = 'auto';
      });
      syncThumbs();
    }

    /* ── Build arrow buttons ── */
    const prevBtn = document.createElement('button');
    prevBtn.className = 'custom-gallery-arrow custom-gallery-arrow--prev';
    prevBtn.setAttribute('aria-label', 'Previous image');
    prevBtn.innerHTML = `<svg fill="none" height="12" viewBox="0 0 8 14" width="8" xmlns="http://www.w3.org/2000/svg"><path d="M6.5 13L1 7l5.5-6" stroke="#000" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg>`;

    const nextBtn = document.createElement('button');
    nextBtn.className = 'custom-gallery-arrow custom-gallery-arrow--next';
    nextBtn.setAttribute('aria-label', 'Next image');
    nextBtn.innerHTML = `<svg fill="none" height="12" viewBox="0 0 8 14" width="8" xmlns="http://www.w3.org/2000/svg"><path d="M1.5 1L7 7l-5.5 6" stroke="#000" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg>`;

    [prevBtn, nextBtn].forEach(btn => {
      Object.assign(btn.style, {
        position       : 'absolute',
        top            : '50%',
        transform      : 'translateY(-50%)',
        width          : '48px',
        height         : '48px',
        borderRadius   : '50%',
        background     : 'rgba(255,255,255,0.95)',
        border         : '1px solid #ddd',
        boxShadow      : '0 2px 8px rgba(0,0,0,0.18)',
        cursor         : 'pointer',
        zIndex         : '9',
        display        : 'flex',
        alignItems     : 'center',
        justifyContent : 'center',
        padding        : '0',
        outline        : 'none',
        transition     : 'box-shadow 0.2s',
        flexShrink     : '0',
      });
      btn.addEventListener('mouseenter', () => btn.style.boxShadow = '0 4px 14px rgba(0,0,0,0.28)');
      btn.addEventListener('mouseleave', () => btn.style.boxShadow = '0 2px 8px rgba(0,0,0,0.18)');
    });

    prevBtn.addEventListener('click', e => { e.stopPropagation(); e.preventDefault(); go(-1); });
    nextBtn.addEventListener('click', e => { e.stopPropagation(); e.preventDefault(); go(1); });

    cssSlider.style.position = 'relative';
    cssSlider.appendChild(prevBtn);
    cssSlider.appendChild(nextBtn);

    /* ── Position arrows vertically centred on the viewport ── */
    function positionArrows() {
      const vRect = viewport.getBoundingClientRect();
      const sRect = cssSlider.getBoundingClientRect();
      if (vRect.height === 0) { setTimeout(positionArrows, 200); return; }

      const centerY = (vRect.top - sRect.top) + vRect.height / 2;
      const vLeft   = vRect.left - sRect.left;
      const vRight  = vLeft + vRect.width;

      prevBtn.style.top   = centerY + 'px';
      nextBtn.style.top   = centerY + 'px';
      prevBtn.style.left  = Math.max(vLeft + 15, 10) + 'px';
      nextBtn.style.right = Math.max(sRect.width - vRight + 15, 10) + 'px';
      nextBtn.style.left  = 'auto';
      prevBtn.style.right = 'auto';
    }

    updateButtons();
    buildClones();

    const tryPos = () => viewport.getBoundingClientRect().height > 0
      ? positionArrows()
      : setTimeout(tryPos, 150);
    tryPos();
    window.addEventListener('resize', positionArrows);
    new ResizeObserver(positionArrows).observe(viewport);

    /* ── Touch / swipe ── */
    let touchStartX = 0, touchStartY = 0, axisDecided = false, isHoriz = false;

    viewport.addEventListener('touchstart', e => {
      touchStartX = e.touches[0].clientX;
      touchStartY = e.touches[0].clientY;
      axisDecided = false; isHoriz = false;
    }, { passive: true });

    viewport.addEventListener('touchmove', e => {
      const dx = e.touches[0].clientX - touchStartX;
      const dy = e.touches[0].clientY - touchStartY;
      if (!axisDecided && (Math.abs(dx) > 8 || Math.abs(dy) > 8)) {
        isHoriz = Math.abs(dx) > Math.abs(dy);
        axisDecided = true;
      }
      if (isHoriz) { e.preventDefault(); e.stopPropagation(); }
    }, { passive: false });

    viewport.addEventListener('touchend', e => {
      if (!axisDecided || !isHoriz) return;
      const dx = e.changedTouches[0].clientX - touchStartX;
      if (Math.abs(dx) >= 20) go(dx < 0 ? 1 : -1);
    }, { passive: false });

    /* ── Mouse wheel (horizontal) ── */
    let wheelLocked = false, wheelAccum = 0;
    viewport.addEventListener('wheel', e => {
      if (Math.abs(e.deltaX) <= Math.abs(e.deltaY)) return;
      e.preventDefault(); e.stopPropagation();
      if (wheelLocked) return;
      wheelAccum += e.deltaX;
      if (Math.abs(wheelAccum) >= 15) {
        const dir = wheelAccum > 0 ? 1 : -1;
        wheelAccum = 0; wheelLocked = true;
        go(dir);
        setTimeout(() => { wheelLocked = false; }, 700);
      }
    }, { passive: false });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initGalleryArrows);
  } else {
    initGalleryArrows();
  }
  document.addEventListener('shopify:section:load', initGalleryArrows);
})();

/* ---- part 19 ---- */
(function () {
  function init() {
    var openBtn = document.querySelector('.hsa-fsa-bar [data-hsa-open]');
    if (!openBtn) return;

    var newBtn = openBtn.cloneNode(true);
    openBtn.parentNode.replaceChild(newBtn, openBtn);

    newBtn.addEventListener('click', function () {
      var appTrigger = document.querySelector('.redo-hsa-learn-more');
      if (appTrigger) {
        appTrigger.click();
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
  document.addEventListener('shopify:block:load', init);
})();


/* ---- moved from section (late block 1) ---- */
(function () {
  // Builds the trigger label for one option element, reading that option's own
  // colours so each picker keeps the badge/save colours of its own block.
  function buildLabelHtml(opt) {
    var title      = opt.dataset.variantTitle;
    var badge      = opt.dataset.variantBadge;
    var price      = opt.dataset.variantPrice;
    var compare    = opt.dataset.variantCompare;
    var savings    = opt.dataset.variantSavings;
    var hasSavings = opt.dataset.variantHasSavings === 'true';
    var existingBadge = opt.querySelector('.vp-badge');
    var bBg    = existingBadge ? existingBadge.style.background : '';
    var bColor = existingBadge ? existingBadge.style.color : '';
    var saveEl = opt.querySelector('.vp-save');
    var sBg    = saveEl ? saveEl.style.background : '';
    var sColor = saveEl ? saveEl.style.color : '';

    return '<div class="main-wrap-title-badge">' +
        '<div class="v-title">' +
          '<span class="vp-variant-name">' + title + '</span>' +
        '</div>' +
        (badge
          ? '<div class="v-badge-main">' +
              '<span class="vp-badge" style="background:' + bBg + ';color:' + bColor + ';">' + badge + '</span>' +
            '</div>'
          : ''
        ) +
      '</div>' +
      '<span class="vp-trigger-prices">' +
        '<div class="vp-opt-right badge-mobile">' +
          (hasSavings
            ? '<div class="mobile-badge"><s class="vp-compare">' + compare + '</s>'
            : ''
          ) +
          '<strong class="vp-price">' + price + '</strong>' +
          '</div>' +
          (hasSavings
            ? '<span class="vp-save" style="background:' + sBg + ';color:' + sColor + ';">SAVE ' + savings + '</span></div>'
            : ''
          ) +
      '</span>';
  }

  // Applies the chosen variant to one picker wrapper: trigger label + the
  // active/selected state of its own option list.
  function paintPicker(wrap, variantId) {
    var opt = wrap.querySelector('[data-vp-option][data-variant-id="' + variantId + '"]');
    if (!opt) return;
    var label = wrap.querySelector('[data-vp-trigger-label]');
    if (label) label.innerHTML = buildLabelHtml(opt);
    wrap.querySelectorAll('[data-vp-option]').forEach(function (o) {
      var on = o === opt;
      o.classList.toggle('vp-option--active', on);
      o.setAttribute('aria-selected', on ? 'true' : 'false');
    });
  }

  document.querySelectorAll('[data-vp-trigger]').forEach(function (trigger) {
    var wrap   = trigger.closest('.vp-dropdown-wrap');
    var list   = wrap.querySelector('.vp-dropdown-list');
    var label  = trigger.querySelector('[data-vp-trigger-label]');
    trigger.addEventListener('click', function () {
      var open = trigger.getAttribute('aria-expanded') === 'true';
      trigger.setAttribute('aria-expanded', open ? 'false' : 'true');
      list.hidden = open;     
    });

    document.addEventListener('click', function (e) {
      if (!wrap.contains(e.target)) {
        trigger.setAttribute('aria-expanded', 'false');
        list.hidden = true;
      }
    });
    list.querySelectorAll('[data-vp-option]').forEach(function (opt) {
      function selectOption() {
        if (opt.classList.contains('vp-option--unavailable')) return;

        var variantId  = opt.dataset.variantId;
        var title      = opt.dataset.variantTitle;
        var badge      = opt.dataset.variantBadge;
        var price      = opt.dataset.variantPrice;
        var compare    = opt.dataset.variantCompare;
        var savings    = opt.dataset.variantSavings;
        var hasSavings = opt.dataset.variantHasSavings === 'true';
        // Repaint every picker on the page, not just the clicked one, so a
        // repeat buy section below the FAQs never shows a different size.
        document.querySelectorAll('.vp-dropdown-wrap').forEach(function (w) {
          paintPicker(w, variantId);
        });

        // One PDP can carry two variant pickers, so there are two sets of
        // native selects. Index each select WITHIN its own <product-variants>
        // wrapper: a flat index would match the second picker against an
        // option value that doesn't exist and leave it out of sync.
        window.__vpSyncNativeSelects(title);

        // ── UPDATE MAIN PRICE BLOCK ──────────────
        if (window.__mpHasCustomDiscount) {
        (function () {
          // querySelectorAll, not querySelector: the PDP can carry more than one
          // price block (e.g. a repeat buy area below the FAQs). With a single
          // match only the first would ever update and the others would sit on a
          // stale price.
          var priceBlocks = document.querySelectorAll('[data-update-block="price-compact-main"]');
          if (!priceBlocks.length) return;

          var cleanPrice   = price.replace(/\.00\b/, '');
          var cleanCompare = compare.replace(/\.00\b/, '');
          var cleanSavings = savings.replace(/\.00\b/, '');

          Array.prototype.forEach.call(priceBlocks, function (priceBlock) {
            function applyCustomPrice() {
              var cur = priceBlock.querySelector('.prc-current-price');
              var cmp = priceBlock.querySelector('.prc-compare-price');
              var sav = priceBlock.querySelector('.prc-savings-badge');
              var bdg = priceBlock.querySelector('.prc-discount-badge');

              if (cur) cur.textContent = cleanPrice;
              if (hasSavings) {
                if (cmp) { cmp.textContent = cleanCompare; cmp.style.display = ''; }
                if (sav) { sav.textContent = 'SAVE ' + cleanSavings; sav.style.display = ''; }
                if (bdg) { bdg.style.display = ''; }
              } else {
                if (cmp) cmp.style.display = 'none';
                if (sav) sav.style.display = 'none';
                if (bdg) bdg.style.display = 'none';
              }
            }
            applyCustomPrice();

            var observer = new MutationObserver(function (mutations, obs) {
              obs.disconnect();
              applyCustomPrice();
            });

            observer.observe(priceBlock, {
              childList: true,
              subtree: true,
              characterData: true
            });
            setTimeout(function () { observer.disconnect(); }, 1000);
          });
        })();
      }

        if (history.replaceState) {
          history.replaceState(null, '', opt.dataset.variantUrl);
        }
        trigger.setAttribute('aria-expanded', 'false');
        list.hidden = true;
      }

      opt.addEventListener('click', selectOption);
      opt.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); selectOption(); }
      });
    });

    list.addEventListener('keydown', function (e) {
      var opts    = Array.from(list.querySelectorAll('[data-vp-option]:not(.vp-option--unavailable)'));
      var focused = document.activeElement;
      var idx     = opts.indexOf(focused);
      if (e.key === 'ArrowDown') { e.preventDefault(); opts[Math.min(idx + 1, opts.length - 1)].focus(); }
      if (e.key === 'ArrowUp')   { e.preventDefault(); opts[Math.max(idx - 1, 0)].focus(); }
      if (e.key === 'Escape')    { trigger.setAttribute('aria-expanded', 'false'); list.hidden = true; trigger.focus(); }
    });
  });

  document.querySelectorAll('[data-vp-size-guide-open]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var modal = document.querySelector('[data-vp-sg-overlay]');
      if (modal) {
        modal.hidden = false;
        modal.querySelector('[data-vp-sg-close]').focus();
      }
    });
  });

  document.querySelectorAll('[data-vp-sg-close]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      btn.closest('[data-vp-sg-overlay]').hidden = true;
    });
  });

  document.querySelectorAll('[data-vp-sg-overlay]').forEach(function (overlay) {
    overlay.addEventListener('click', function (e) {
      if (e.target === overlay) overlay.hidden = true;
    });
    overlay.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') overlay.hidden = true;
    });
  });
  })();
  document.addEventListener('change', function () {
    setTimeout(function () {
      document.querySelectorAll('.vp-price, .vp-compare, .vp-save').forEach(function (el) {
        if (el.innerText.includes('.00')) {
          el.innerText = el.innerText.replace(/\.00\b/, '');
        }
      });
    }, 0);
  });

/* ---- moved from section (late block 2) ---- */
document.addEventListener("DOMContentLoaded", function () {

      

  // Bind EVERY buy_buttons block, not just the first. The repeat buy section
  // under the FAQs has its own form and its own button; without this its click
  // falls through to the theme's plain submit and the free gift and upsell
  // products are silently left out of the cart.
  const addToCartBtns = Array.prototype.slice.call(
    document.querySelectorAll('form[action="/cart/add"] [type="submit"]')
  );

  if (!addToCartBtns.length) return;

  // Upsell toggles belong to the buy section they sit above: everything between
  // the previous add-to-cart button and this one. Without this split, ticking
  // both gift boxes would add the same free product twice.
  function upsellsFor(btn) {
    const idx = addToCartBtns.indexOf(btn);
    const prev = idx > 0 ? addToCartBtns[idx - 1] : null;
    return Array.prototype.slice
      .call(document.querySelectorAll(".upsell-input:checked"))
      .filter(function (input) {
        if (!(btn.compareDocumentPosition(input) & Node.DOCUMENT_POSITION_PRECEDING)) return false;
        if (!prev) return true;
        return !!(prev.compareDocumentPosition(input) & Node.DOCUMENT_POSITION_FOLLOWING);
      });
  }

  // Trim gift lines back to the number of main products actually in the cart.
  //
  // Two things conspire to over-add. Shopify CLAMPS a tracked variant to the
  // stock that is left ("stop selling when out of stock"), silently and with a
  // 200 — and it applies that clamp on the NEXT cart mutation, i.e. when the
  // gift is added, so no response from the main add reveals it. Meanwhile a
  // Buy X get Y discount SPLITS the gift into two lines (the free one and the
  // charged remainder), and enforceGiftSync() on the cart page skips any group
  // with more than one line. Net effect: ask for 3 mattresses with 2 in stock
  // and the cart holds 2 mattresses and 3 pillows, the third of them charged.
  //
  // Read the cart once at the end and drop the surplus.
  async function reconcileGifts(mainProductId) {
    try {
      const cart = await (await fetch("/cart.js")).json();
      if (!cart || !cart.items) return;

      const isGift = (i) => i.properties && i.properties._upsell_is_gift === "true";

      // Every size of the product counts towards the gift total, so a cart with
      // two different mattresses gets one pillow line covering both.
      const mainTotal = cart.items
        .filter(function (i) { return String(i.product_id) === mainProductId && !isGift(i); })
        .reduce(function (n, i) { return n + i.quantity; }, 0);

      // group the gift lines by gift variant, for this parent product only
      const groups = {};
      cart.items.forEach(function (i) {
        if (!isGift(i)) return;
        if (String(i.properties._upsell_parent_product_id || "") !== mainProductId) return;
        const key = String(i.variant_id);
        (groups[key] = groups[key] || []).push(i);
      });

      const updates = {};
      Object.keys(groups).forEach(function (key) {
        const lines = groups[key];
        const perMain = parseInt(lines[0].properties._upsell_per_main_qty, 10) || 1;
        let remaining = mainTotal * perMain;
        lines.forEach(function (line) {
          const keep = Math.min(line.quantity, Math.max(remaining, 0));
          if (keep !== line.quantity) updates[line.key] = keep;
          remaining -= keep;
        });
      });

      if (Object.keys(updates).length) {
        await fetch("/cart/update.js", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ updates: updates })
        });
      }
    } catch (e) {
      // never block the redirect on this
      console.warn("[Upsell] gift reconcile skipped:", e);
    }
  }

  // Keep a capped add-on (recycling service: at most 10 old mattresses) at or
  // under its maximum across the whole cart. The PDP stepper stops at the
  // maximum, but a second visit adds on top of what the cart already holds.
  // Trims the newest lines first.
  async function capAddons(products) {
    const caps = {};
    products.forEach(function (p) {
      if (p.maxQty > 0) caps[String(p.id)] = p.maxQty;
    });
    if (!Object.keys(caps).length) return;
    try {
      const cart = await (await fetch("/cart.js")).json();
      if (!cart || !cart.items) return;
      const updates = {};
      Object.keys(caps).forEach(function (variantId) {
        let remaining = caps[variantId];
        cart.items
          .filter(function (i) { return String(i.variant_id) === variantId; })
          // cart.js lists the newest line first; walk oldest-first so the
          // trim lands on what was just added
          .reverse()
          .forEach(function (line) {
            const keep = Math.min(line.quantity, Math.max(remaining, 0));
            if (keep !== line.quantity) updates[line.key] = keep;
            remaining -= keep;
          });
      });
      if (Object.keys(updates).length) {
        await fetch("/cart/update.js", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ updates: updates })
        });
      }
    } catch (e) {
      // never block the redirect on this
      console.warn("[Upsell] add-on cap skipped:", e);
    }
  }

  addToCartBtns.forEach(function (addToCartBtn) {

  let isAddingToCart = false;

  addToCartBtn.addEventListener("click", async function (e) {
    e.preventDefault();

    if (isAddingToCart) return;
    isAddingToCart = true;
    addToCartBtn.disabled = true;
    addToCartBtn.setAttribute('aria-busy', 'true');
    addToCartBtn.classList.add('working');

    const form = addToCartBtn.closest("form");
    const formData = new FormData(form);
   const checkedUpsells = upsellsFor(addToCartBtn);

    let techText = [];
    let extraProducts = [];

    // The - / + stepper, read from THIS form. (It used to read .qty-dropdown,
    // which no longer exists, so gift quantities were always stuck at 1.)
    const mainQtyEl = form.querySelector('[name="quantity"]');
    const mainQuantity = Math.max(1, parseInt(mainQtyEl?.value || "1", 10) || 1);

    checkedUpsells.forEach(input => {
      const type = input.dataset.type;
      const variantId = input.dataset.variantId;

      const label = input
        .closest(".upsell-row")
        .querySelector(".upsell-label strong")?.innerText.trim();

      if (type === "tech") {
        techText.push(label);
      }

   if (type === "product" && variantId) {
  const baseQty = parseInt(input.dataset.quantity || "1", 10);
  // data-qty-fixed: the customer chose this count themselves (the recycling
  // service's 回收張數), so it is NOT scaled by the mattress quantity.
  const qtyFixed = input.dataset.qtyFixed === "true";
  const quantity = qtyFixed ? baseQty : baseQty * mainQuantity;
  const maxQty = parseInt(input.dataset.maxQuantity || "", 10);

  const productTitle = input.dataset.title || "";
  const labelup = `${productTitle}`;

  const mainVariantInput = form.querySelector('input[name="id"]');
  const mainVariantId = mainVariantInput ? mainVariantInput.value : null;
  const mainProductInput = form.querySelector('[name="product-id"]');
  const mainProductId = mainProductInput ? String(mainProductInput.value) : "";

  // Only a toggle marked free is a gift. This used to be hardcoded "true" for
  // every product upsell, which made the cart render the PAID recycling service
  // with the upsell_free styling — shown as free, charged at NT$1,500.
  // The cart templates all compare against the literal "true".
  const isGift = input.dataset.free === "true";

  extraProducts.push({
    id: variantId,
    quantity,
    baseQty,
    maxQty: maxQty > 0 ? maxQty : 0,
    // Line-item properties decide line IDENTITY: two adds merge into one line
    // only when their properties match exactly. Anything that varies per add —
    // the chosen variant, the running quantity — forces a second line, which is
    // why changing the size used to stack up duplicate pillow lines instead of
    // bumping the quantity. So the parent is recorded as the PRODUCT, which is
    // the same whichever size is picked, and the quantity is left out entirely
    // (the cart line already knows its own quantity).
    // A fixed-count add-on (the recycling service) gets the same properties on
    // every add -- no per-add count, no parent product -- so buying mattress A
    // with 1 and mattress B with 2 grows ONE line to 3 instead of splitting it.
    // _upsell_max_qty caps the cart row's own quantity control.
    properties: qtyFixed ? {
      _upsell_is_gift: "false",
      _upsell_label: labelup || "abc",
      _upsell_max_qty: maxQty > 0 ? maxQty : 10
    } : {
      _upsell_is_gift: isGift ? "true" : "false",
      _upsell_per_main_qty: baseQty,
      _upsell_label: labelup || "abc",
      _upsell_parent_product_id: mainProductId
    }
  });
}
    });
    if (techText.length) {
      formData.append("properties[Upgrade]", techText.join(", "));
    }

    try {
      const mainRes = await fetch("/cart/add.js", {
        method: "POST",
        body: formData
      });

      if (!mainRes.ok) throw new Error("Main product failed");
      if (extraProducts.length) {
        await fetch("/cart/add.js", {
          method: "POST",
          headers: {
            "Content-Type": "application/json"
          },
          body: JSON.stringify({
            items: extraProducts.map(function (p) {
              return { id: p.id, quantity: p.quantity, properties: p.properties };
            })
          })
        });
      }

      await reconcileGifts(String(formData.get("product-id") || ""));
      await capAddons(extraProducts);
      window.location.href = "/cart";

    } catch (err) {
      console.error("Cart error:", err);
      isAddingToCart = false;
      addToCartBtn.disabled = false;
      addToCartBtn.removeAttribute('aria-busy');
      addToCartBtn.classList.remove('working');
    }

  });

  });

 const timers = document.querySelectorAll('[id^="countdown-timer-"]');

  timers.forEach(timer => {
    const id = timer.id.replace("countdown-timer-", "");
    const endTime = new Date(timer.getAttribute("data-endtime")).getTime();

    const daysEl = document.getElementById(`days-${id}`);
    const hoursEl = document.getElementById(`hours-${id}`);
    const minutesEl = document.getElementById(`minutes-${id}`);
    const secondsEl = document.getElementById(`seconds-${id}`);

    function updateCountdown() {
      const now = new Date().getTime();
      const distance = endTime - now;

      if (distance <= 0) {
        timer.style.display = "none";
        clearInterval(interval);
        return;
      }

      const days = Math.floor(distance / (1000 * 60 * 60 * 24));
      const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((distance % (1000 * 60)) / 1000);

      if (daysEl) daysEl.textContent = ("0" + days).slice(-2);
      if (hoursEl) hoursEl.textContent = ("0" + hours).slice(-2);
      if (minutesEl) minutesEl.textContent = ("0" + minutes).slice(-2);
      if (secondsEl) secondsEl.textContent = ("0" + seconds).slice(-2);
    }

    updateCountdown();
    const interval = setInterval(updateCountdown, 1000);
  });

});

/* ---- repeat buy section: secondary product-form wiring ---- */
/* section-main-product.js binds the cart-drawer opener with a single
   this.querySelector('[data-js-product-form]'), so only the FIRST buy_buttons
   block opens the drawer after adding to cart. Wire up every further form here.
   Each <product-form> still handles its own AJAX submit (custom elements run
   connectedCallback per instance) — this only restores the drawer. */
(function () {
  function wireExtraForms() {
    var forms = document.querySelectorAll('[data-js-product-form]');
    Array.prototype.slice.call(forms, 1).forEach(function (form) {
      if (form.dataset.bbDrawerWired === 'true') return;
      form.dataset.bbDrawerWired = 'true';
      form.addEventListener('add-to-cart', function () {
        var drawer = document.getElementById('site-cart-sidebar');
        if (drawer && typeof drawer.show === 'function') drawer.show();
        var recs = document.getElementById('cart-recommendations-sidebar');
        if (recs && typeof recs.generateRecommendations === 'function') {
          recs.generateRecommendations();
        }
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', wireExtraForms);
  } else {
    wireExtraForms();
  }
  document.addEventListener('shopify:section:load', wireExtraForms);
  document.addEventListener('shopify:block:load', wireExtraForms);
})();

/* ---- returning to the PDP: reset the buy form ---- */
/* Coming back from the cart (back button, or a bfcache restore) the browser
   hands back the form exactly as it was left — quantity 3, the recycling box
   still ticked — while the order summary and the price block have re-rendered
   from the server at their defaults. The two then disagree on screen: the
   stepper says 3 and the checkbox is ticked, but the summary shows one item and
   no add-on line.

   Reset the controls to what the server actually rendered (the value/checked
   ATTRIBUTES, so this follows the block settings rather than hardcoding) and
   fire the events so everything downstream re-renders in step. */
(function () {
  function resetBuyForm() {
    document.querySelectorAll('form[action*="/cart/add"] [name="quantity"]').forEach(function (q) {
      var def = q.getAttribute('value') || '1';
      if (q.value !== def) {
        q.value = def;
        q.dispatchEvent(new Event('input', { bubbles: true }));
        q.dispatchEvent(new Event('change', { bubbles: true }));
      }

      // keep the two quantity styles in step with the reset
      var dropdown = q.parentNode && q.parentNode.querySelector('.qty-dropdown');
      if (dropdown) dropdown.value = def;

      // component-quantity-selector.js tracks its own disabled state on the
      // buttons and never sees a programmatic value change, so redo it here.
      var holder = q.closest('product-quantity');
      if (holder) {
        var min = parseInt(q.getAttribute('min'), 10) || 1;
        var max = parseInt(q.getAttribute('max'), 10) || 99999;
        var now = parseInt(def, 10) || min;
        var minus = holder.querySelector('.qty-minus');
        var plus = holder.querySelector('.qty-plus');
        if (minus) minus.classList.toggle('disabled', now - 1 < min);
        if (plus) plus.classList.toggle('disabled', now + 1 > max);
      }
    });

    // defaultChecked is the `checked` attribute as rendered, so a gift toggle
    // that ships ticked stays ticked and the add-on returns to unticked.
    document.querySelectorAll('.upsell-input').forEach(function (cb) {
      if (cb.checked !== cb.defaultChecked) {
        cb.checked = cb.defaultChecked;
        cb.dispatchEvent(new Event('change', { bubbles: true }));
      }
    });
  }

  function isBackForward() {
    try {
      var nav = performance.getEntriesByType('navigation')[0];
      return !!(nav && nav.type === 'back_forward');
    } catch (e) { return false; }
  }

  // Must be pageshow, not DOMContentLoaded. Chrome restores the saved form
  // values AFTER parsing, so resetting on DOMContentLoaded is undone a moment
  // later and the stale quantity comes back. pageshow fires after restoration,
  // for both the bfcache case (persisted) and an ordinary back/forward.
  // Add-to-cart puts the button into a submitting state and then navigates to
  // /cart. Coming back, the bfcache restores the page exactly as it was left --
  // button still disabled, aria-busy set, and isAddingToCart still true, which
  // makes the very first click a no-op. Clear it whenever we return to the page.
  function resetAddToCartState() {
    isAddingToCart = false;
    document.querySelectorAll('[data-js-product-add-to-cart]').forEach(function (btn) {
      btn.classList.remove('working');
      btn.removeAttribute('aria-busy');
      // Only re-enable what WE disabled. A sold-out variant is disabled by the
      // markup and must stay that way.
      if (!btn.classList.contains('disabled')) btn.disabled = false;
    });
  }

  // The header's cart count and total are server-rendered, so a restored page
  // still shows what the cart held before the add. Re-read it and write the
  // real numbers back; the existing observer on the badge hides it at zero.
  function refreshHeaderCart() {
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (cart) {
        if (!cart) return;
        document.querySelectorAll('[data-header-cart-count]').forEach(function (el) {
          el.textContent = cart.item_count;
        });
        var totals = document.querySelectorAll('[data-header-cart-total]');
        if (!totals.length) return;
        var fmt = (window.KROWN && KROWN.settings && KROWN.settings.shop_money_format) || '';
        var amount = (cart.total_price / 100).toLocaleString('en-US', { maximumFractionDigits: 0 });
        var text = fmt ? fmt.replace(/\{\{\s*amount[_a-z]*\s*\}\}/, amount) : amount;
        totals.forEach(function (el) { el.textContent = text; });
      })
      .catch(function () { /* leave the rendered values alone */ });
  }

  window.addEventListener('pageshow', function (e) {
    if (!e.persisted && !isBackForward()) return;
    resetAddToCartState();
    resetBuyForm();
    refreshHeaderCart();
    // one more pass after the current task, in case a restore lands late
    setTimeout(function () { resetAddToCartState(); resetBuyForm(); }, 0);
  });
})();

/* ---- part 21 — recycling choice ----

   snippets/pdp-recycling-addon.liquid renders 舊床墊回收服務 as two radios
   (不需要回收 / the paid service) and marks the group required, but nothing
   read data-recycle-required or the error element, so "required" was purely
   cosmetic -- a shopper could still add to cart without answering, which is
   the exact thing the radios were introduced to prevent.

   Cart side needs nothing here. The service is added by the add-to-cart
   handler, which reads ".upsell-input:checked" at submit time; the 不需要回收
   radio deliberately has no .upsell-input, so choosing it simply means nothing
   is added. (Part 1 looks like it also adds on toggle, but part 13 puts a
   capture-phase listener on every .upsell-input that calls
   stopImmediatePropagation, so no change-driven cart code ever runs.)

   Delegated from document: the buy area re-renders on variant change, and a
   page can hold more than one of these groups. */
(function () {
  function groups() {
    return Array.prototype.slice.call(document.querySelectorAll('[data-recycle-group]'));
  }

  function showError(group, show) {
    var err = group.querySelector('[data-recycle-error]');
    if (err) err.hidden = !show;
    group.classList.toggle('has-error', !!show);
  }

  /* Clear the warning as soon as either radio is picked. Capture phase,
     because part 13 stops change events dead at .upsell-input -- a listener on
     the bubble path would never see the paid option being chosen. */
  document.addEventListener('change', function (e) {
    var input = e.target;
    if (!input || input.type !== 'radio') return;
    var group = input.closest && input.closest('[data-recycle-group]');
    if (group) showError(group, false);
  }, true);

  function firstUnanswered() {
    var g = groups();
    for (var i = 0; i < g.length; i++) {
      if (g[i].dataset.recycleRequired !== 'true') continue;
      if (g[i].querySelector('input[type="radio"]:checked')) continue;
      return g[i];
    }
    return null;
  }

  function block(e) {
    var group = firstUnanswered();
    if (!group) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    showError(group, true);
    group.scrollIntoView({ behavior: 'smooth', block: 'center' });
    var first = group.querySelector('input[type="radio"]');
    if (first) first.focus({ preventScroll: true });
  }

  // Capture phase, before the theme's own add-to-cart handling.
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-js-product-add-to-cart], [name="add"]');
    if (btn) block(e);
  }, true);

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (form && form.getAttribute('action') === '/cart/add') block(e);
  }, true);
})();

/* ---- part 22 — recycling quantity (回收張數) ----

   snippets/pdp-recycling-addon.liquid shows a - / + stepper under
   需要回收舊床墊 once it is selected. The count is the customer's own number
   of old mattresses: 1 to 2 x the mattress quantity, never above
   data-max-quantity (8 per order). Its value is written into the paid radio's
   data-quantity -- the one place the add-to-cart handler and the order summary
   read it from -- and the radio's data-variant-title is rebuilt from its
   template so the summary line reads 舊床墊回收服務 - 回收 3 張.

   A change event is raised on the radio afterwards so the order summary
   re-renders; part 13 stops it at the radio, but the summary listens in the
   capture phase at document and still sees it.

   Delegated from document: the buy area re-renders on variant change. */
(function () {
  function parts(el) {
    var card = el.closest && el.closest('.recycle-addon__card');
    if (!card) return null;
    var radio = card.querySelector('.upsell-input');
    var input = card.querySelector('[data-recycle-qty-input]');
    if (!radio || !input) return null;
    return { card: card, radio: radio, input: input };
  }

  // Each new mattress takes away at most 2 old ones (the WooCommerce rule, also
  // enforced by the app's checkout rule), so the stepper stops at
  // 2 x the mattress quantity, and never above data-max-quantity (8 per order).
  var PER_MATTRESS = 2;
  function mattressQty(card) {
    var form = card.closest('form[action*="/cart/add"]');
    var q = (form || document).querySelector(form ? '[name="quantity"]' : 'form[action*="/cart/add"] [name="quantity"]');
    return Math.max(1, parseInt(q && q.value, 10) || 1);
  }

  function apply(p, value) {
    var max = Math.min(
      parseInt(p.radio.dataset.maxQuantity, 10) || 8,
      PER_MATTRESS * mattressQty(p.card)
    );
    var n = parseInt(value, 10);
    if (isNaN(n)) n = parseInt(p.radio.dataset.quantity, 10) || 1;
    n = Math.min(Math.max(n, 1), max);

    p.input.value = String(n);
    p.card.querySelectorAll('[data-recycle-step]').forEach(function (btn) {
      btn.disabled = parseInt(btn.dataset.recycleStep, 10) < 0 ? n <= 1 : n >= max;
    });

    if (p.radio.dataset.quantity === String(n)) return;
    p.radio.dataset.quantity = String(n);
    var tpl = p.radio.dataset.variantTitleTemplate;
    if (tpl) p.radio.dataset.variantTitle = tpl.split('[qty]').join(String(n));
    p.radio.dispatchEvent(new Event('change', { bubbles: true }));
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-recycle-step]');
    if (!btn) return;
    e.preventDefault();
    var p = parts(btn);
    if (p) apply(p, (parseInt(p.input.value, 10) || 1) + parseInt(btn.dataset.recycleStep, 10));
  });

  document.addEventListener('change', function (e) {
    if (!e.target.matches || !e.target.matches('[data-recycle-qty-input]')) return;
    var p = parts(e.target);
    if (p) apply(p, e.target.value);
  });

  // Enter in the number field would otherwise submit the product form.
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter' || !e.target.matches || !e.target.matches('[data-recycle-qty-input]')) return;
    e.preventDefault();
    var p = parts(e.target);
    if (p) apply(p, e.target.value);
  });

  // The mattress quantity sets the ceiling: re-clamp when it changes. The
  // quantity buttons update the field without always raising an event, so
  // look again just after a click on them too.
  document.addEventListener('change', function (e) {
    if (e.target.matches && e.target.matches('form[action*="/cart/add"] [name="quantity"]')) syncAll();
  });
  document.addEventListener('input', function (e) {
    if (e.target.matches && e.target.matches('form[action*="/cart/add"] [name="quantity"]')) syncAll();
  });
  document.addEventListener('click', function (e) {
    if (e.target.closest && e.target.closest('product-quantity, .quantity')) setTimeout(syncAll, 0);
  });

  // Coming back from the cart the browser may restore the typed value while
  // the radio's data-quantity starts fresh, so re-read on pageshow too.
  function syncAll() {
    document.querySelectorAll('[data-recycle-qty-input]').forEach(function (input) {
      var p = parts(input);
      if (p) apply(p, input.value);
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', syncAll);
  } else {
    syncAll();
  }
  window.addEventListener('pageshow', syncAll);
})();
